import { TableCell } from '@mui/material'

import { HeaderProps } from './types'
import { useHeader } from './useHeader'

export const Header = <T,>({ header, ...props }: HeaderProps<T>): React.JSX.Element => {
  const { colSpan, Content, id, onSort, styles } = useHeader({ header, ...props })

  return (
    <TableCell
      colSpan={colSpan}
      data-cy={`table-header-${id}`}
      data-product-fruits={header.column.columnDef.meta?.headerProductFruitsSelector}
      key={id}
      onClick={onSort}
      sx={styles}
    >
      {Content}
    </TableCell>
  )
}
